import { createApp } from 'vue';
import { parseJSON } from '../../utils/helper-functions';
import commonStore from '../global/common-store';
import app from './app.vue';

let isWishlistInitialized = false;
let isWishlistRefreshBound = false;

const initWishlist = () => {
  if (!isWishlistInitialized) {
    commonStore.dispatch('fetchWishlistItems');
    isWishlistInitialized = true;
  }

  if (!isWishlistRefreshBound) {
    window.addEventListener('refreshWishlist', () => {
      commonStore.dispatch('fetchWishlistItems');
    });
    isWishlistRefreshBound = true;
  }
};

const mountTabbedProductCards = (root = document) => {
  let hasMountedCards = false;

  root.querySelectorAll('script[data-tabbed-product-collection]').forEach((scriptEl) => {
    const blockId = scriptEl.dataset.tabbedProductCollection;
    const data = parseJSON(scriptEl.innerHTML);

    root
      .querySelectorAll(`.tabbed-product-carousel__product[data-tabbed-product-collection="${blockId}"]`)
      .forEach((slideEl) => {
        const mountEl = slideEl.querySelector('.tabbed-product-carousel__product-card');
        const productIndex = Number(slideEl.dataset.productIndex);
        const product = data.products && data.products[productIndex];

        if (!mountEl || !product || mountEl.dataset.productCardMounted === 'true') return;

        let productCardApp = createApp(app, {
          data: {
            product,
            callouts: data.callouts || [],
            useLifestyleImage: !!data.useLifestyleImage,
            showDiscountBadge: data.showDiscountBadge !== false,
          },
        });

        productCardApp = productCardApp.use(commonStore);
        productCardApp.mount(mountEl);
        mountEl.dataset.productCardMounted = 'true';
        hasMountedCards = true;
      });
  });

  if (root.querySelector('.yotpo-widget-instance') && typeof window.loadYotpo === 'function') {
    window.loadYotpo();
  }

  if (hasMountedCards && typeof window.refreshYotpoData === 'function') {
    window.refreshYotpoData();
  }
};

const observeSections = () => {
  const sections = document.querySelectorAll('.tabbed-product-carousel');
  if (!sections.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          initWishlist();
          mountTabbedProductCards(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '200px' }
  );

  sections.forEach((section) => observer.observe(section));
};

export default () => {
  observeSections();

  document.addEventListener('shopify:section:load', (event) => {
    initWishlist();
    mountTabbedProductCards(event.target);
  });
};
